/**
 * Műveletek lenyíló menü — mobil-kompatibilis
 */
import { useState, useEffect, useRef, useCallback } from 'react';

export interface ActionItem {
  label: string;
  icon?: string;
  onClick: () => void;
  danger?: boolean;
  separator?: boolean;
  variant?: 'danger';
}

export default function ActionsDropdown({ actions }: { actions: ActionItem[] }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const btnRef = useRef<HTMLButtonElement>(null);
  const [pos, setPos] = useState<{ top: number; right: number }>({ top: 0, right: 0 });

  const updatePos = useCallback(() => {
    if (!btnRef.current) return;
    const rect = btnRef.current.getBoundingClientRect();
    setPos({
      top: rect.bottom + 4,
      right: Math.max(12, window.innerWidth - rect.right),
    });
  }, []);

  useEffect(() => {
    if (!open) return;
    updatePos();
    const close = (e: MouseEvent | TouchEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node) &&
          btnRef.current && !btnRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', close);
    document.addEventListener('touchstart', close, { passive: true });
    return () => {
      document.removeEventListener('mousedown', close);
      document.removeEventListener('touchstart', close);
    };
  }, [open, updatePos]);

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        ref={btnRef}
        className="btn btn-ghost"
        style={{ padding: '6px 12px', fontSize: '12px', minHeight: '32px' }}
        onClick={(e) => { e.stopPropagation(); e.preventDefault(); updatePos(); setOpen(!open); }}
      >
        Műveletek ▾
      </button>
      {open && (
        <div ref={ref} style={{
          position: 'fixed',
          top: pos.top,
          right: pos.right,
          zIndex: 200,
          background: 'var(--paper)',
          border: '1px solid var(--line)',
          borderRadius: 'var(--r)',
          boxShadow: '0 12px 30px -10px rgba(20,35,63,.3)',
          minWidth: '200px',
          maxWidth: 'calc(100vw - 24px)',
          padding: '6px',
        }}>
          {actions.map((a, i) => (
            a.separator ? (
              <div key={i} style={{ height: '1px', background: 'var(--line-2)', margin: '4px 0' }} />
            ) : (
              <button
                key={i}
                onClick={(e) => { e.stopPropagation(); e.preventDefault(); a.onClick(); setOpen(false); }}
                className="dd-item"
                style={a.danger || a.variant === 'danger' ? { color: 'var(--red)' } : undefined}
              >
                {a.icon && <span style={{ fontSize: '14px', width: '20px', textAlign: 'center' }}>{a.icon}</span>}
                {a.label}
              </button>
            )
          ))}
        </div>
      )}
    </div>
  );
}
